import Vue from 'vue';
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import store from 'Store/index';
import BaseComponent from 'Components/Base/ABaseComponent';
import { FavoriteList, AddItemToFavoriteListCommand, RemoveItemFromFavoriteListCommand, CreateFavoriteListCommand } from 'Api/CoreApi';


export interface FavoriteListIsActive extends BaseComponent{
    isActive: boolean;
}

@Component({
    template: "#favorite-list-menu-template"
})
export default class FavoriteListMenuComponent extends Mixins(BaseComponent) {
    
    
    addNewList: string = '';

    addNewListNameInput: string = '';

    allowClose: boolean = false;


    async created(){
        this.setLoaded();
    }

    async mounted() {
    }


    get productKey()
    {
        return store.state.favoriteList.currentProductKey;
    }

    //solve the favoritelist for the current product selected.
    //-set favoritelist as active if product exists on it
    get allFavoriteLists() {
        //hack to trigger re-rendering of component
        var test= store.state.favoriteList.detectChanges;
        const currentProductKey = store.state.favoriteList.currentProductKey;
        //TODO - get detail list instead - !! we don't need all the references here
        const favoriteLists = store.state.favoriteList.favoriteLists;
        const productmap = store.state.favoriteList.productsMap;
        if(!(currentProductKey && favoriteLists)) return store.state.favoriteList.currentProductKey;

        const list: FavoriteListIsActive[] = [];
        try{

            favoriteLists.forEach(x => {
            // //be careful- we actually manipulation the list for the store
            // //we have to set alle favoritelists as inactive before
                let obj: FavoriteListIsActive = <any>x;
                obj.isActive = false;
                if(productmap.has(currentProductKey)){
                    obj.isActive = productmap.get(currentProductKey).favoriteListIds.some(y => y == x.id);
                }
                list.push(obj)
            });
        }catch(err){
            //ensures the list is empty
            return <any>[];
        }
        return list; 
    }




    get showMenu(){
        return store.state.favoriteList.favoriteListMenuShow;
    }

    closeFoldOut() {
        if (!this.allowClose) {
            this.allowClose = true;
        } else {
            this.allowClose = false;
            store.state.favoriteList.favoriteListMenuShow = false;
            //todo set inactive instead..
            //favoriteList.setFavoriteListInactive();
            // store.dispatch.favoriteList.toggleFavoriteListMenu();
        }
    }

    saveAsNewList() {
        if (this.addNewListNameInput.trim().length === 0) {
            this.setError('You need to type in a favorite list name.');
            return;
        }
        this.clearError();

        this.addProductToNewList();
    }

    toggleItem(event: any, favoriteListId: number) {
        if (event.currentTarget.checked) {
            this.addProductToList(favoriteListId);
        } else {
            this.removeProductFromList(favoriteListId);
        }
    }
    

    private async addProductToList(favoriteListId: number) {
        this.startDelayedLoading();
           await store.dispatch.favoriteList.addItemOnFavoriteList(new AddItemToFavoriteListCommand({
            favoriteListId: favoriteListId,
            productKey: store.state.favoriteList.currentProductKey
        })); 
        this.stopDelayedLoading();
    }

    private async removeProductFromList(favoriteListId: number) {
        this.startDelayedLoading();
        await store.dispatch.favoriteList.removeItemOnFavoriteList(new RemoveItemFromFavoriteListCommand({
            favoriteListId: favoriteListId,
            productKey: store.state.favoriteList.currentProductKey
        }));
        this.stopDelayedLoading();
    }

    async addProductToNewList() {
        this.startDelayedLoading();
        await store.dispatch.favoriteList.createFavoriteList(new CreateFavoriteListCommand({
            name: this.addNewListNameInput,
            productKey : store.state.favoriteList.currentProductKey
        }));
        this.addNewListNameInput = '';
        this.addNewList = '';
        this.stopDelayedLoading();
    }


}

Vue.component('favorite-list-menu', FavoriteListMenuComponent);